<i [ngClass]="icon_classes"></i>
<tooltip-popover [tooltip_content]="tooltip_content"></tooltip-popover>
